module.exports = __webpack_public_path__ + "img/db9ee3b.jpg";